import axiosClient from '../../axios'
import { useQuery } from '@tanstack/react-query'
import { getSavedAuthData } from '../../axios/interceptor'
import { IUser } from '../../../types/users'
import { IUserWithModules } from '../../../types/modules'

export function useMyProfile() {
  const { userId } = getSavedAuthData()
  return useQuery({
    staleTime: 50000,
    queryKey: [userId],
    queryFn: async () => {
      const { data } = await axiosClient.get<IUser>('/users/profile')
      return data
    },
  })
}

export function useMyProfileWithModules() {
  const { userId } = getSavedAuthData()
  return useQuery({
    staleTime: 50000,
    queryKey: [userId, 'modules'],
    queryFn: async () => {
      const { data } = await axiosClient.get<IUserWithModules>('/users/profile/modules')
      return data
    },
  })
}
